/* eslint-disable camelcase */
import React from "react";
import { useTranslation } from "ceco-polyglot";
import { MoreVertical, Edit, Delete } from "ceicons";
import Pill from "../Pill";
import AllergenRecipeModal from "../../modals/AllergenRecipeModal";
import { AllergenRecipeDeleteModal } from "../../modals/AllergenRecipeDeleteModal";
import DropDownButton from "../../DropDownButton";

export default function AllergensList({
  allergens,
  recipeId,
  allAllergen,
  refetchData,
  recipeName,
}) {
  const t = useTranslation();

  return (
    <div className="pills allergens-list">
      {allergens &&
        allergens.map((allergen, i) => {
          return (
            <div className={`pill`} key={i}>
              <span className="number">{i + 1}</span>
              <span className="text">{allergen.allergen.name}</span>

              <DropDownButton icon={<MoreVertical />}>
                <AllergenRecipeModal
                  recipeId={recipeId}
                  edit
                  allergen={allergen}
                  allAllergen={allAllergen}
                  refetchData={refetchData}
                  trigger={
                    <div>
                      <Edit />
                      <p>{t("popup.edit")}</p>
                    </div>
                  }
                />
                <AllergenRecipeDeleteModal
                  recipeName={recipeName}
                  allergen={allergen}
                  refetchData={refetchData}
                  trigger={
                    <div className="delete-modal">
                      <Delete />
                      <p>{t("popup.remove")}</p>
                    </div>
                  }
                />
              </DropDownButton>
            </div>
          );
        })}

      <AllergenRecipeModal
        recipeId={recipeId}
        refetchData={refetchData}
        allAllergen={allAllergen}
        trigger={
          <span>
            <Pill newItem text={t("pill.addAllergen")} />
          </span>
        }
      />
    </div>
  );
}
